// style
export const TOGGLE_LIGHT = "TOGGLE_LIGHT"
export const TOGGLE_DARK = "TOGGLE_DARK"

// Brands
export const CREATE_BRAND = "CREATE_BRAND"
export const UPDATE_BRAND = "UPDATE_BRAND"
export const DELETE_BRAND = "DELETE_BRAND"
export const RESET_BRANDS = "RESET_BRANDS"
export const GENERATE_BRANDS = "GENERATE_BRANDS"

// Data
export const FETCH_COMPLETE = "FETCH_COMPLETE"
export const FETCH_ERROR = "FETCH_ERROR"
export const FETCH_START = "FETCH_START"

// Championships
export const GENERATE_CHAMPIONSHIPS = "GENERATE_CHAMPIONSHIPS"
export const CREATE_CHAMPIONSHIP = "CREATE_CHAMPIONSHIP"
export const UPDATE_CHAMPIONSHIP = "UPDATE_CHAMPIONSHIP"
export const DELETE_CHAMPIONSHIP = "DELETE_CHAMPIONSHIP"
export const RESET_CHAMPIONSHIPS = "RESET_CHAMPIONSHIPS"

// Game
export const CHECK_VERSION = "CHECK_VERSION"
export const GENERATE = "GENERATE"
export const RESET_GAME = "RESET_GAME"
export const UPDATE_GAME = "UPDATE_GAME"
export const UPDATE_SIMULATION = "UPDATE_SIMULATION"

// Roster
export const GENERATE_ROSTER = "GENERATE_ROSTER"
export const CREATE_WRESTLER = "CREATE_WRESTLER"
export const UPDATE_WRESTLER = "UPDATE_WRESTLER"
export const RESET_ROSTER = "RESET_ROSTER"
export const UPDATE_ROSTER = "UPDATE_ROSTER"

// Shows
export const CREATE_SHOW = "CREATE_SHOW"
export const UPDATE_SHOW = "UPDATE_SHOW"
export const DELETE_SHOW = "DELETE_SHOW"
export const RESET_SHOWS = "RESET_SHOWS"
export const GENERATE_SHOWS = "GENERATE_SHOWS"

// Matches
export const GENERATE_MATCHES = "GENERATE_MATCHES"
export const CREATE_MATCH = "CREATE_MATCH"
export const SELECT_WINNER_IN_MATCH = "SELECT_WINNER_IN_MATCH"
export const REMOVE_WRESTLER_FROM_MATCH = "REMOVE_WRESTLER_FROM_MATCH"
export const DELETE_WRESTLER = "DELETE_WRESTLER"
export const ADD_WRESTLER_TO_MATCH = "ADD_WRESTLER_TO_MATCH"
export const SIMULATE_MATCH = "SIMULATE_MATCH"
export const RESET_MATCHES = "RESET_MATCHES"
export const CLEAR_WRESTLERS_FROM_MATCH = "CLEAR_WRESTLERS_FROM_MATCH"
export const RANDOMISE_MATCH = "RANDOMISE_MATCH"
export const RESET_MATCH = "RESET_MATCH"

// Battle Royal
export const RESET_BATTLE_ROYAL = "RESET_BATTLE_ROYAL"
export const UPDATE_BATTLE_ROYAL = "UPDATE_BATTLE_ROYAL"

// Resets
export const RESET = "RESET"

// Droppables
export const WRESTLER = "WRESTLER"



// WEBPACK FOOTER //
// ./src/actions/types.js